"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const react_merge_refs_1 = __importDefault(require("react-merge-refs"));
const resize_observer_1 = require("@juggle/resize-observer");
const react_use_measure_1 = __importDefault(require("react-use-measure"));
// this hook combines potentially a plain ref that the client provides with a ref used by react-use-measure
// this is important because react-measure uses a functionnal ref that cannot be used afterwards by the client to eg manipulate the DOM
// also provides a polyfill to react-use-measure for ResizeObserver compatibility with Safari etc...
exports.default = (extRef, delay) => {
    // instantiate a functional ref with the react-measure resize observer
    const options = react_1.useMemo(() => ({
        debounce: delay,
        scroll: false,
        polyfill: resize_observer_1.ResizeObserver
    }), [delay]);
    const result = react_use_measure_1.default(options);
    // merge with client ref
    if (extRef) {
        result[0] = react_merge_refs_1.default([extRef, result[0]]);
    }
    return result;
};
//# sourceMappingURL=index.js.map